import axios, { AxiosError, AxiosInstance } from "axios";
import { httpClient } from "./httpClient";

const LOGIN_PATH = "/lk/login";
const APP_BASE = "/lk";

function normalizeNextPath(path: string): string {
    if (!path) return "/";
    const raw = String(path).trim();
    if (!raw.startsWith("/")) return "/";
    if (raw === APP_BASE) return "/";
    if (raw.startsWith(`${APP_BASE}/`)) {
        return raw.slice(APP_BASE.length) || "/";
    }
    return raw;
}

function isLoginPost(config: { url?: string; method?: string } | undefined): boolean {
    if (!config?.url) return false;
    const method = (config.method || "get").toLowerCase();
    const url = config.url.toLowerCase();
    return method === "post" && url.includes("/login");
}

function shouldRedirectToLogin(): boolean {
    const p = window.location.pathname || "";
    if (p.endsWith("/login") || p.endsWith("/login/")) return false;
    return true;
}

const AUTH_FRESH_KEY = "lk_auth_fresh";
/** Окно после входа: первый 401 часто из‑за задержки cookie; один повтор запроса без выхода на форму. */
const AUTH_FRESH_MS = 15000;

function attachUnauthorizedRedirect(client: AxiosInstance) {
    client.interceptors.response.use(
        (response) => response,
        async (error: AxiosError) => {
            let err: AxiosError = error;
            const status = err.response?.status;
            const cfg = err.config;

            if (status === 401 && cfg && !isLoginPost(cfg)) {
                const extCfg = cfg as { __lk401Retry?: boolean };
                let fresh: string | null = null;
                try {
                    fresh = sessionStorage.getItem(AUTH_FRESH_KEY);
                } catch {
                    fresh = null;
                }
                if (fresh && !extCfg.__lk401Retry) {
                    const t = parseInt(fresh, 10);
                    if (!Number.isNaN(t) && Date.now() - t < AUTH_FRESH_MS) {
                        extCfg.__lk401Retry = true;
                        await new Promise((r) => setTimeout(r, 150));
                        try {
                            return await client.request(cfg);
                        } catch (e) {
                            err = e as AxiosError;
                        }
                    }
                }

                const finalStatus = err.response?.status;
                if (finalStatus === 401 && err.config && !isLoginPost(err.config)) {
                    try {
                        localStorage.removeItem("user");
                    } catch {
                        /* ignore */
                    }
                    if (shouldRedirectToLogin()) {
                        (err as any).__authRedirect = true;
                        const next = normalizeNextPath(
                            window.location.pathname + window.location.search + window.location.hash
                        );
                        window.location.assign(`${LOGIN_PATH}?next=${encodeURIComponent(next)}`);
                    }
                }
            }

            return Promise.reject(err);
        }
    );
}

/** Реакция на 401: очистка localStorage и переход на форму входа (кроме запроса POST /login). */
export function configureAxiosAuth() {
    attachUnauthorizedRedirect(axios);
    attachUnauthorizedRedirect(httpClient);
}
